import { Component, OnInit, ChangeDetectorRef, ViewChild, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { ExceptionHelper } from './../../../../helper';
import { IsActive } from './../../../../model';
import { DatePipe } from '@angular/common';

import { EcallSummaryService } from './ecall-summary.service';

import * as $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4';

@Component({
  selector: 'app-ecall-summary',
  templateUrl: './ecall-summary.component.html',
  styleUrls: [
    '../../../../../scss/vendors/bs-datepicker/bs-datepicker.scss'
  ],
  encapsulation: ViewEncapsulation.None
})
export class EcallSummaryComponent implements OnInit, AfterViewInit {

  @ViewChild('dangerModal') dangerModal: any;

  @ViewChild('created') private createdCheckbox;
  @ViewChild('received') private receivedCheckbox;
  @ViewChild('arrived') private arrivedCheckbox;
  @ViewChild('completed') private completedCheckbox;
  @ViewChild('cancelled') private cancelledCheckbox;
  @ViewChild('dateRange') private dateRangeCheckbox ;

  // for managing checkboxes
  created: any;
  received: any;
  arrived: any;
  completed: any;
  cancelled: any;
  dateRange: any;

  isCreated = false;
  isReceived = false;
  isArrived = false;
  isCompleted = true;
  isCancelled = false;
  isDateRange = false;

  applied: Boolean = true;

  // for setting default date of ngbDatePicker
  today: Date = new Date();
  startOFmonth: Date = new Date();
  lastMonth: Date = new Date();
  todayFM: String;
  startOFmonthFM: String;
  lastMonthFM: String;
  startDate: String;
  endDate: String;
  bsRangeValue: any;

  ecalls: any[];
  dataTable: any;

  customerId;

  constructor(private chRef: ChangeDetectorRef,
    private exception: ExceptionHelper,
    private datePipe: DatePipe,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private ecallSummaryService: EcallSummaryService,
    private translateService: TranslateService) {
    translateService.setDefaultLang('en-us');
    this.route.params.subscribe(params => { this.customerId = params['customerId']; });
  }

  ngAfterViewInit() {
    this.created = this.createdCheckbox.nativeElement;
    this.received = this.receivedCheckbox.nativeElement;
    this.arrived = this.arrivedCheckbox.nativeElement;
    this.completed = this.completedCheckbox.nativeElement;
    this.cancelled = this.cancelledCheckbox.nativeElement;
    this.dateRange = this.dateRangeCheckbox.nativeElement;

    this.getSummary('', '', IsActive.inactive, IsActive.inactive, IsActive.inactive, IsActive.active, IsActive.inactive);
  }

  ngOnInit() {
    // set ngbDatePicker default value
    this.startOFmonth.setDate(1);
    this.lastMonth.setMonth(this.lastMonth.getMonth() - 1);
    this.bsRangeValue = [];
    this.todayFM = this.datePipe.transform(this.today, 'yyyy-MM-dd'),
      this.startOFmonthFM = this.datePipe.transform(this.startOFmonth, 'yyyy-MM-dd'),
      this.lastMonthFM = this.datePipe.transform(this.lastMonth, 'yyyy-MM-dd'),
      this.startDate = this.lastMonthFM;
    this.endDate = this.todayFM;
  }

  apply() {
    this.isCreated = this.created.checked;
    this.isReceived = this.received.checked;
    this.isArrived = this.arrived.checked;
    this.isCompleted = this.completed.checked;
    this.isCancelled = this.cancelled.checked;
    this.isDateRange = this.dateRange.checked;

    // setting params for api
    const para_created = (this.created.checked === true ? IsActive.active : IsActive.inactive);
    const para_received = (this.received.checked === true ? IsActive.active : IsActive.inactive);
    const para_arrived = (this.arrived.checked === true ? IsActive.active : IsActive.inactive);
    const para_completed = (this.completed.checked === true ? IsActive.active : IsActive.inactive);
    const para_cancelled = (this.cancelled.checked === true ? IsActive.active : IsActive.inactive);

    // add params later
    if (this.isDateRange && this.bsRangeValue.length === 2) {
      this.getSummary(this.datePipe.transform(this.bsRangeValue[0], 'yyyy-MM-dd'),
      this.datePipe.transform(this.bsRangeValue[1], 'yyyy-MM-dd'),
      para_created, para_received, para_arrived, para_completed, para_cancelled);
    } else {
      this.getSummary('', '',
        para_created, para_received, para_arrived, para_completed, para_cancelled);
    }

  }

  filterChange() {

    if (this.isCreated === this.created.checked && this.isReceived === this.received.checked && this.isArrived === this.arrived.checked &&
      this.isCompleted === this.completed.checked && this.isCancelled === this.cancelled.checked &&
      this.startDate === this.datePipe.transform(this.bsRangeValue[0], 'yyyy-MM-dd') &&
      this.endDate === this.datePipe.transform(this.bsRangeValue[1], 'yyyy-MM-dd')) {
      // unchanged
      this.applied = true;
    } else if (this.created.checked || this.received.checked || this.arrived.checked || this.completed.checked || this.cancelled.checked) {
      this.applied = false;
    } else {
      this.applied = true;
    }

    this.applied = this.dateRange === this.dateRange.checked;

  }

  getSummary(startDate, endDate, created, received, arrived, completed, cancelled) {
    const all = (this.customerId == null ? true : false);

    this.ecallSummaryService.getSummary(startDate, endDate, created, received, arrived, completed, cancelled, all, this.customerId)
      .subscribe((data: any) => {
        this.applied = true;
        if ($.fn.dataTable.isDataTable('#ecallDataTables')) { $('#ecallDataTables').DataTable().destroy(); }

        this.ecalls = data.ecallDetailListModel;
        // for (const ecall of this.ecalls) {
        //   ecall.creationTime = ecall.creationTime.substr(0, 10);
        // }

        this.chRef.detectChanges();

        const table: any = $('#ecallDataTables');
        this.dataTable = table.DataTable({
          'order': [[3 , 'desc']]
        });
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
      });
  }
  public onDateRangeChange(): void {
    this.applied = !(this.dateRange.checked === true);
  }
  errorClose() {
    if (this.customerId != null) {
      this.router.navigate(['/home/customers/detail/' + this.customerId]);
    } else {
      this.dangerModal.hide();
    }
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/ecall/ecall-summary/ecall-summary.component.ts